module.exports = __webpack_public_path__ + "static/img/image029.a8a74df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image029.png
// module id = DRko
// module chunks = 1